import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AngularFireAuth } from '@angular/fire/auth';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';

interface user {
  uid: string
  fotoPerfil: string,
  primerNombre: string,
  nombreCompleto: string,
  token: string,
}

@Component({
  selector: 'menu-vertical',
  templateUrl: './menu-vertical.component.html',
  styleUrls: ['./menu-vertical.component.css']
})
export class MenuVerticalComponent implements OnInit {
 

  public loaded = 0 // spinner

  // media predeterminada
  logo: string = "assets/images/logos/logo.svg"
  imgUsuario: string = "assets/images/default/default-user-image.jpg";

  menuOpen: number = 0;

  // auxiliar buscador
  textoBusqueda: string = "";
  usuario = JSON.parse(localStorage.getItem('user'))
  token = JSON.parse(localStorage.getItem('token'))

  constructor(
    public authService: AuthService,
    public dialog: MatDialog,
    private shared: RoutingVariablesService,
    private router: Router,
  ) { }

  ngOnInit(): void {  
  }

  buscarTexto() {
    const obj = { textoBusqueda: this.textoBusqueda };
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }

  signOut() {
    this.authService.SignOut();
  }

}